import React, {Component, Fragment} from 'react'
import {DateTime} from 'luxon'

class CountdownTimer extends Component {
    constructor(props) {
        super(props)
        this.endDate = DateTime
            .fromFormat(
                props.endDate,
                `yyyy-M-d`,
                {
                    zone: props.timezone
            })
            .endOf(
                `day`,
                {
                    useLocaleWeeks: false
                }
            )
        this.state = {
            seconds: 0,
            minutes: 0,
            hours: 0,
            diff: ``
        }
    }

    render() {
        const updateTime = () => {
            let seconds = Math.floor(this.endDate.diff(DateTime.now(), `seconds`).toMillis() / 1000)
            let minutes = (seconds - (seconds % 60)) / 60
            let hours = (minutes - (minutes % 60)) / 60
            this.setState({
                diff: seconds,
                seconds: seconds % 60,
                minutes: minutes % 60,
                hours: hours
            })
        }

        setInterval(updateTime, 1000)
        return (
            <>
                <div className={`time-fragment`}>
                    <h4>{this.state.hours}</h4>
                    <sub>HRS</sub>
                </div>
                :
                <div className={`time-fragment`}>
                    <h4>{this.state.minutes}</h4>
                    <sub>MINS</sub>
                </div>
                :
                <div className={`time-fragment`}>
                    <h4>{this.state.seconds}</h4>
                    <sub>SECS</sub>
                </div>
            </>
        )
    }
}

export default CountdownTimer
